var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.child_support.tax_type)?_c('div',{attrs:{"id":"child-support"}},[_c('p',{staticClass:"headline"},[_vm._v("\n    Deduction: "),_c('Money',{attrs:{"amount":_vm.child_support.deduction}})],1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }